@use '../colors.scss' as colors;
@use '../vars.scss' as vars;

.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: 'Rubik', sans-serif;
  background-color: white;

  @supports (-webkit-touch-callout: none) {
    min-height: -webkit-fill-available;
  }
}

.padder {
  padding-left: 16px;
  padding-right: 16px;
}

.wrapper-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  padding: 16px;
  border-top: 1px solid colors.$light-grey;
  margin-top: 32px;

  .icons {
    width: 13px;
    height: 13px;
    color: colors.$label;
    margin-right: 5px;
  }

  a,
  button {
    color: colors.$link !important;
  }

  a:hover {
    color: colors.$uplift-green !important;
    text-decoration: underline;
  }

  button:hover {
    color: #333 !important;
  }

  @media screen and (max-width: vars.$mobile) {
    flex-direction: column;
  }
}

.wrapper-footer-contact {
  display: flex;
}

.wrapper-contact {
  display: flex;
  align-items: center;
  padding-right: 5px;
}

.wrapper-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  border-bottom: 1px solid colors.$light-grey;
  color: colors.$header;
  line-height: 16px;

  a {
    font-weight: 500;
    color: colors.$link;
    font-size: 16px;

    &:hover {
      color: colors.$link;
      text-decoration: underline;
    }
  }
}

.wrapper-header-text {
  display: flex;
  font-weight: 500;

  span {
    white-space: pre;
  }

  @media screen and (max-width: vars.$mobile) {
    flex-direction: column;
  }
}

.wrapper-header-logo {
  display: flex;
  align-items: center;
  font-size: 12.8px;
}

.wrapper-dismissible-banner {
  width: 66.6666%;
  display: flex;
  flex-direction: column;
  margin: 12px auto 20px auto;
  padding: 15px;
  background-color: #eff4fa;
  font-size: 12.8px;
  border-radius: 4px;

  @media screen and (max-width: vars.$mobile) {
    width: 83.3333%;
  }
}

.wrapper-dismissible-banner-exit {
  align-self: flex-end;
  padding-right: 6px;
}

.wrapper-dismissible-banner-text {
  padding: 0 6px;
  display: flex;
  align-items: flex-start;
  line-height: 22px;
}

.wrapper-alert {
  margin: 3px 20px 0 0;
}

.wrapper-alert-icon {
  width: 20px;
  height: 20px;
  background-color: #dc0606;
  text-align: center;
  color: colors.$white;
  font-size: 20px;
  border-radius: 20px;
}

.wrapper-dismissible-banner-dismiss {
  align-self: flex-end;
  font-weight: 500;
  padding-right: 6px;

  a:hover {
    color: #333;
  }
}

// Flexpay
:global(.flexpay) {
  .wrapper-header {
    line-height: 20px;
    border-bottom: 1px solid colors.$flexpay-border;
  }

  .wrapper-header-logo {
    font-size: 10px;
    font-weight: 500;

    @media screen and (max-width: vars.$mobile) {
      flex-direction: column;
      align-items: start;

      .wrapper-header-logo-powered-by {
        margin-left: 5px;
      }
    }
  }

  .wrapper-footer {
    border: none;

    .footer-header {
      color: colors.$flexpay-title;
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
    }

    .icons {
      color: colors.$flexpay-title;
    }

    :global(.svg-globe) g {
      fill: colors.$flexpay-title !important;
    }

    a,
    button {
      color: colors.$flexpay-title !important;
      text-decoration: underline;
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
    }
  }
}
